import type { SuretyAccountId } from "@inrev/common";
import { UploadedDocuments } from "@portal/components/uploaded-documents";
import { FC } from "react";

type AdminUploadedDocumentsProps = {
	accountId: SuretyAccountId;
};

export const AdminUploadedDocuments: FC<AdminUploadedDocumentsProps> = ({ accountId }) => {
	return (
		<div data-testid="admin-uploaded-documents" className="flex flex-col">
			<UploadedDocuments accountId={accountId} useCardLayout />
		</div>
	);
};
